module.exports = __webpack_public_path__ + "static/media/skin.4f40e260.png";


//////////////////
// WEBPACK FOOTER
// ./src/CSS/assets-minified/skin.png
// module id = ./src/CSS/assets-minified/skin.png
// module chunks = 0